import { render, staticRenderFns } from "./OrderCart.vue?vue&type=template&id=2b378a80"
import script from "./OrderCart.vue?vue&type=script&lang=ts"
export * from "./OrderCart.vue?vue&type=script&lang=ts"
import style0 from "./OrderCart.vue?vue&type=style&index=0&id=2b378a80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports